import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RpcError, StatusCode } from 'grpc-web';
import { API_URL, getCurrentLng, getHeaders, ApiMessage, toApiMessage, APIRequest, APIResponse, getSession, refreshSession } from '../../../../app/Api';
import { formatDate, timestampToDate } from '../../../../app/Helpers';

import { TableState } from '../../../common/Table/TableSate';
import { UserTypeEndpointClient ,} from '../../../../repository/UserManagement/UsertypeServiceClientPb';
import { GetUserTypesRequest, GetUserTypesResponse } from '../../../../repository/UserManagement/organization_pb';
import { DeleteUserTypeResponse, DeleteUserTypeRequest } from '../../../../repository/UserManagement/usertype_pb';
import { number } from 'yup';
import { OrganizationEndpointClient } from '../../../../repository/UserManagement/OrganizationServiceClientPb';


export interface UserTypesPageState {
    userTypes: TableState
    isChangeStateLoading: boolean,
    message?: ApiMessage,
    searchText: string | undefined,
    filters: any[]
}

const initialState: UserTypesPageState = {
    userTypes: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    isChangeStateLoading: false,
    message: undefined,
    searchText: undefined,
    filters: []
}

const clientUserTypes = new UserTypeEndpointClient(API_URL, null, null);
const clientOrg = new OrganizationEndpointClient(API_URL, null, null);


export const getUserTypes = createAsyncThunk<GetUserTypesResponse.AsObject, APIRequest<GetUserTypesRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/customers/userTypes/getUserTypes',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await clientOrg.getUserTypes(req.body, req.headers ?? {});
                return r.toObject();
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)


export const deleteUserType = createAsyncThunk<APIResponse<DeleteUserTypeResponse.AsObject>, APIRequest<DeleteUserTypeRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/customers/userTypes/delete',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {
                var r = await clientUserTypes.delete(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getId() }, response: r.toObject() };
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }

        }
        return await callReq();
    }

)

const getFilters = (state: UserTypesPageState): any[] => {


    return [];

}

export const customersUserTypesPageSlice = createSlice({
    name: 'pages/customers/userTypes',
    initialState,
    reducers: {
        dismissMessage: (state) => {
            state.message = undefined;
        },
        reset: (state) => {
            state.message = initialState.message;
            state.userTypes = initialState.userTypes;
            state.isChangeStateLoading = initialState.isChangeStateLoading;
            state.searchText = initialState.searchText;
        },
        resetUserTypes: (state) => {
            state.userTypes.items = [];
            state.userTypes.hasMore = true;
        },

        setSort: (state, action: PayloadAction<boolean>) => {
            state.userTypes.isDescending = action.payload;
        },
        setNumberOfResults: (state, action: PayloadAction<number>) => {
            state.userTypes.numberOfResults = action.payload;
        },
        setSelectedUserType: (state, action: PayloadAction<any[]>) => {
            state.userTypes.selected = action.payload;
        },
        setSearchText: (state, action: PayloadAction<string | undefined>) => {
            state.searchText = action.payload;
        },
        setIsFilteredSet: (state, action: PayloadAction<boolean>) => {
            state.userTypes.isFilteredSet = action.payload;
        },
        addUserType: (state, action: PayloadAction<any>) => {
            if (!state.userTypes.isFilteredSet) {
                if (!state.userTypes.hasMore && !state.userTypes.isDescending) {
                    state.userTypes.items.push(action.payload);
                } else if (state.userTypes.isDescending) {
                    state.userTypes.items.unshift(action.payload);
                }
            }
        },
        updateUserType: (state, action: PayloadAction<any>) => {
            let selected = state.userTypes.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).id == action?.payload?.id) {
                    selected[0] = action?.payload
                }
                var u = state.userTypes.items.findIndex(e => e.id == action?.payload?.id)
                if (u >= 0) {
                    state.userTypes.items[u] = action?.payload
                }
            }

        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUserTypes.fulfilled, (state, { payload }) => {
            state.userTypes.isFetching = false
            if (payload) {
                var r = (payload?.success?.usertypesList.map(val => {
                    return {
                        id: val.id,
                        name: val.name?.value ?? "",
                        userTypeCategory: val.usertypecategory,
                        createdDate: formatDate(timestampToDate(val.createddate?.seconds, val.createddate?.nanos)),
                        addedBy: (val.addedby?.firstname?.value ?? "") + " " + (val.addedby?.lastname?.value ?? ""),
                        addedById: val.addedby?.id?.value,
                    }
                }
                ) as any[])
                //r = (r.concat(...Array(9).fill(r)));
                let l = [];
                if (state.userTypes.items.length != 0) {
                    l = state.userTypes.items.slice(0, state.userTypes.items.length - 10)
                }
                l = l.concat(r);
                if (r.length < state.userTypes.numberOfResults) {
                    state.userTypes.hasMore = false;
                } else {
                    l = l.concat(...Array(10).fill(null));
                }

                state.userTypes.items = l
                //console.log(state.items)

            } else {
                state.userTypes.hasMore = false;
            }
        })
        builder.addCase(getUserTypes.rejected, (state, action) => {
            state.userTypes.isFetching = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(getUserTypes.pending, (state, action) => {
            state.userTypes.isFetching = true;
            state.message = undefined;
        })



        builder.addCase(deleteUserType.fulfilled, (state, { payload }) => {
            state.isChangeStateLoading = false;
            if (payload) {
                state.message = toApiMessage(payload?.response.success?.message);
                let selected = state.userTypes.selected;
                if (payload?.metadata) {
                    if (selected.length > 0 && selected.at(0).id == payload?.metadata.id) {
                        state.userTypes.selected = []
                    }
                    var u = state.userTypes.items.findIndex(e => e.id == payload?.metadata.id)
                    if (u >= 0) {
                        state.userTypes.items.splice(u, 1);
                    }
                }
            }
        })
        builder.addCase(deleteUserType.rejected, (state, action) => {
            state.isChangeStateLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(deleteUserType.pending, (state, action) => {
            state.isChangeStateLoading = true;
            state.message = undefined;
        })




    }
})

export const { reset, dismissMessage, setSort, setNumberOfResults, resetUserTypes, setSelectedUserType, setSearchText, setIsFilteredSet, updateUserType, addUserType } = customersUserTypesPageSlice.actions

export default customersUserTypesPageSlice.reducer


